import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders, umsUrl, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { GET_BRAND_SERVICE, GET_BRAND_SERVICE_SUCCESS, GET_BRAND_SERVICE_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';

function* getBrandService({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/admin/brand-service-configs`,
      method: 'GET',
      headers: {
        // Authorization: Constant?.CLIENT_TOKEN,
        ...filteredHeaders,
        // withCredentials: true
      },
      params: payload?.data,
    });

    if (response.status === 200) {
      yield put({
        type: GET_BRAND_SERVICE_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_BRAND_SERVICE_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_BRAND_SERVICE_ERROR, payload: error });
  }
}

export function* watchBrandService() {
  yield takeEvery(GET_BRAND_SERVICE, getBrandService);
}

function* watchBrandServiceSaga() {
  yield all([fork(watchBrandService)]);
}

export default watchBrandServiceSaga;
